import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { showHubTeamToast } from "../utils/hub_team_toast"
import { selectionFormData, selectedMemberCount, reloadRoster } from "../utils/roster_selection"

export default class extends Controller {
  static targets = ["modal", "title", "description", "submitButton"]
  static values = { url: String }

  connect() {
    this.selectedCount = 0
  }

  open(event) {
    event.preventDefault()

    this.selectedCount = selectedMemberCount(this)
    if (this.selectedCount === 0) return

    this.updateCopy(this.selectedCount)
    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  async save(event) {
    event.preventDefault()

    if (selectedMemberCount(this) === 0 || !this.hasUrlValue) return

    this.setSaving(true)

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: selectionFormData(this),
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })

      const data = await response.json()

      if (response.ok && data.success) {
        Modal.getOrCreateInstance(this.modalTarget).hide()
        this.closeEditPanel()

        if (data.skipped_count > 0) {
          showHubTeamToast(
            `${data.deactivated_count || 0} member(s) deactivated. ${data.skipped_count} could not be deactivated.`
          )
        }

        reloadRoster(this)
      } else {
        const message = data?.errors?.join(", ") || `HTTP ${response.status}`
        showHubTeamToast(`Failed to deactivate members: ${message}`, { variant: "error" })
      }
    } catch (error) {
      console.error("Error deactivating company members:", error)
      showHubTeamToast("An error occurred. Please try again.", { variant: "error" })
    } finally {
      this.setSaving(false)
    }
  }

  updateCopy(count) {
    const noun = count === 1 ? "member" : "members"

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = `Deactivate ${count} ${noun}`
    }

    if (this.hasDescriptionTarget) {
      this.descriptionTarget.textContent =
        `${count} ${noun} will lose access to this team. This action cannot be undone.`
    }

    if (this.hasSubmitButtonTarget && this.submitButtonTarget.dataset.saving !== "true") {
      this.submitButtonTarget.textContent = count === 1 ? "Deactivate 1 member" : `Deactivate ${count} members`
    }
  }

  // The panel may be showing one of the members that just lost access.
  closeEditPanel() {
    const editPanel = this.element.querySelector("[data-edit-member-panel-target='panel']")
    if (!editPanel || editPanel.hidden) return

    this.application.getControllerForElementAndIdentifier(this.element, "edit-member-panel")?.close()
  }

  setSaving(saving) {
    if (!this.hasSubmitButtonTarget) return

    this.submitButtonTarget.dataset.saving = saving ? "true" : "false"
    this.submitButtonTarget.disabled = saving

    if (saving) {
      this.submitButtonTarget.textContent = "Deactivating..."
    } else {
      this.updateCopy(this.selectedCount)
    }
  }
}
